module.exports = __webpack_public_path__ + "static/media/tai-chi.e7b9e4de.png";